module.exports = "/dist/images/42ed7ab34b124b1017e5ef2b832f48ab-location.ico";